import { user } from '$lib/stores/user/store';
import { get } from 'svelte/store';
import { PAGES } from '$lib/utils/constants';
import { postAuthenticationPathService } from '$lib/services/post-authentication-path';

export const LOGIN_EXCEPTION_HANDLER = async () => {
	return PAGES.INTERNAL.LOGIN;
};

export const ROUTE_TO_NMHP_HANDLER = async () => {
	return PAGES.INTERNAL.HOME;
};

export const REG_PATH_EXCEPTION_HANDLER = async () => {
	const currentUser = get(user);
	return postAuthenticationPathService.getRedirectPath(currentUser);
};

export const ROUTE_TO_PARENT_SECTION_HANDLER = async () => {
	return PAGES.INTERNAL.PARENT_SECTION.DEFAULT;
};
